document.addEventListener("DOMContentLoaded", function() {
    const fm_wrappers = document.querySelectorAll('.fm-carousel'); // main carousel wrappers

    fm_wrappers.forEach(fm_wrapper => {
        let fm_overflow = fm_wrapper.querySelector('.fm-carousel-container'); // carousel inner wrapper
        let fm_counter = fm_wrapper.querySelector('.fm-counter');
        let fm_bullets = fm_wrapper.querySelector('.fm-carousel-bullets');
        let fm_control = fm_wrapper.querySelector('.fm-autoplay-control');
        let fm_prev = fm_wrapper.querySelector('.fm-prev');
        let fm_next = fm_wrapper.querySelector('.fm-next');
        let fm_slides = fm_overflow.querySelectorAll('li');
        let fm_last = fm_slides.length - 1;
        let touchstart = 0;
        let touchend = 0;
        let index = 1;
        let vertical = fm_wrapper.classList.contains('vertical');
        let xy = vertical ? 'top' : 'left';
        let dimension = vertical ? 'height' : 'width';
        let touchDirection = vertical ? 'screenY' : 'screenX';
        let activeSlide = Array.from(fm_slides).find(node => node.classList.contains('active'));
        const gapOffset = parseInt(getComputedStyle(fm_overflow).getPropertyValue('gap')) // gap offset

        const rawSlideSpeed = getComputedStyle(fm_overflow).getPropertyValue('--slideSpeed').trim(); // Get slider transition speed from CSS
        const slideSpeed = rawSlideSpeed.endsWith('ms') ? rawSlideSpeed : `${parseFloat(rawSlideSpeed) * 1000}`; // Convert to milliseconds if speed was set to 0.3s insead of 300ms

        const fm_index = (step = null) => {
            index = (index + step + fm_slides.length) % fm_slides.length || fm_slides.length; // index = current step if > length set to 1, else set to total
            return index;
        };

        const fm_count = (step = null) => {
            index = fm_index(step)
            fm_counter.innerHTML = `Slide ${index} of ${fm_slides.length}`;
        };

        // Function to add or remove event listeners
        const toggleEventListeners = (add) => {
            const action = add ? 'addEventListener' : 'removeEventListener';
            fm_prev[action]('click', fm_slide);
            fm_next[action]('click', fm_slide);
            fm_overflow[action]('touchstart', setTouchstart, { passive: true });
            fm_overflow[action]('touchend', setTouchend, { passive: true });
            document[action]('touchmove', preventScroll, { passive: false });
        };

        // Prevent screen from scrolling when using touch event on carousel
        const preventScroll = (e) => {
            if (!fm_overflow.contains(e.target)) { return; } // Touch event outside the vertical carousel, allow scrolling
            e.preventDefault();
        };

        fm_slides.forEach((slide, index) => {
            let active = (index == 0) ? 'class="active"' : '';
            fm_bullets.insertAdjacentHTML('beforeend', `<li ${active}><a href="#${slide.id}" aria-label="slide ${index + 1}"></a></li>`);
        });



        // Slides carousel
        const fm_slide = (e) => {
            fm_slides = fm_overflow.querySelectorAll('li');
            activeSlide = Array.from(fm_slides).find(node => node.classList.contains('active')); // get active slide
            let next = (e == 'next' || (e.currentTarget && e.currentTarget.classList.contains('fm-next'))); // set next var to true/false depending if next clicked or not
            let direction = next ? 1 : -1;
            let slide_size = next ? Math.round(activeSlide.getBoundingClientRect()[dimension]) : Math.round(fm_slides[direction + 2].getBoundingClientRect()[dimension]); //set width/height to current slide if next clicked, else if prev, set to next slide width/height
            fm_overflow.classList.add('sliding'); // add sliding class to add transition to moving the carousel
            fm_overflow.style[xy] = `${parseInt(fm_overflow.style[xy]) - direction * slide_size + (next ? -gapOffset : gapOffset)}px`; // move carousel
            activeSlide.classList.remove('active'); // remove active class from previously active slide
            fm_slides[direction + 2].classList.add('active'); // add active class to next active slide
            fm_slides.forEach(slide => {
                slide.querySelector('a, iframe')?.setAttribute('tabindex', slide.classList.contains('active') ? '0' : '-1'); // Prevent tabbing into the inactive slides
            });
            fm_slides.forEach(slide => slide.setAttribute('aria-hidden', slide !== fm_slides[direction + 2])); // set all but the active class to hidden

            toggleEventListeners(false); // remove event listeners
            fm_count(direction); // Set counter text

            fm_bullets.querySelector('.active')?.classList.remove('active'); // remove active from previous bullet
            fm_bullets.querySelector('li:nth-child('+(fm_index() + 1)+')').classList.add('active'); // add active to next bullet

            setTimeout(() => {
                fm_overflow.classList.remove('sliding');
                next ? fm_slides[fm_last].after(fm_slides[0]) : fm_slides[0].before(fm_slides[fm_last]); // if next clicked, move first sldie to last position else if prev clicked move last slide to first position
                slide_size = next ? Math.round(fm_slides[0].getBoundingClientRect()[dimension] + gapOffset) : Math.round(fm_slides[fm_last].getBoundingClientRect()[dimension] + gapOffset); // prev
                fm_overflow.style[xy] = `${parseInt(fm_overflow.style[xy]) + (next ? slide_size : -slide_size)}px`; // move slides (If next clicked, add, else prev was clicked so subtract)
                toggleEventListeners(true);
            }, parseFloat(slideSpeed));
        };

        fm_slides[0].classList.add('active');
        fm_slides[0].setAttribute('aria-hidden', false);
        fm_slides.forEach(slide => {
            // Prevent tabbing into the inactive slides
            slide.querySelector('a, iframe')?.setAttribute('tabindex', slide.classList.contains('active') ? '0' : '-1');
        });
        fm_slides[0].before(fm_slides[fm_slides.length - 2]); // move second last slide to first position
        fm_slides[0].before(fm_slides[fm_last]); // move last slide to first position

        var x = window.matchMedia("(max-width: 600px)"); // Create a MediaQueryList object
        let mobileOffset = x.matches && dimension != 'height' ? 40 : 0; // Set mobile offset based on the media query
        fm_overflow.style[xy] = `-${fm_slides[fm_slides.length - 2].getBoundingClientRect()[dimension] + fm_slides[fm_last].getBoundingClientRect()[dimension] + (gapOffset*2) - mobileOffset}px`; // works for both horizontal/vertical
        fm_count(); // Set counter text

        window.addEventListener('resize', (e) => {
            mobileOffset = x.matches && dimension != 'height' ? 40 : 0; // Set mobile offset based on the media query
            fm_slides = fm_overflow.querySelectorAll('li');
            fm_overflow.style[xy] = `-${fm_slides[0].getBoundingClientRect()[dimension] + fm_slides[1].getBoundingClientRect()[dimension] + (gapOffset*2) - mobileOffset}px`;
        }, true);



        /* Start of autoplay feature */
        let autoplay = 0;
        let autoScrollInterval;
        const rawAutoSpeed = getComputedStyle(fm_overflow).getPropertyValue('--autoSpeed').trim(); // Get slider transition speed from CSS
        const autoSpeed = rawAutoSpeed.endsWith('ms') ? rawAutoSpeed : `${parseFloat(rawAutoSpeed) * 1000}`; // Convert to milliseconds if speed was set to 0.3s insead of 300ms
        
        const startAutoScroll = () => {
            // Check if user has preferred reduced motion
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                clearInterval(autoScrollInterval);
                autoplay = 0;
            } else {
                fm_overflow.removeAttribute("aria-live");
                fm_counter.removeAttribute("aria-live");
                fm_control.classList.remove('disabled');
                autoScrollInterval = setInterval(() => {
                    fm_slide('next');
                }, parseFloat(autoSpeed));
                autoplay = 1;
            }
        };

        const stopAutoScroll = () => {
            fm_overflow.setAttribute("aria-live", "polite");
            fm_counter.setAttribute("aria-live", "polite");
            clearInterval(autoScrollInterval);
            autoplay = 0;
        };

        // Autoplay carousel if autoplay class exists
        if (fm_wrapper.classList.contains('autoplay')) {
            startAutoScroll();

            // Event listener to stop auto scroll on control button click
            fm_control.addEventListener('click', () => {
                fm_wrapper.classList.toggle('autoplay');
                fm_control.innerHTML = fm_control.innerHTML === '￭' ? '▶' : '￭';

            });

            // Event listeners to pause autoplay when mouse is over fm_wrapper
            fm_wrapper.addEventListener('mouseenter', () => autoplay && stopAutoScroll()); // on mouse enter, if autoplay true, stop
            fm_wrapper.addEventListener('mouseleave', () => fm_wrapper.classList.contains('autoplay') && !autoplay && startAutoScroll()); // on mouse leave if no autoplay class and autoplay is false, start
        }
        /* End of autoplay feature */



        // Introduce a flag to track whether the carousel is sliding
        let sliding = false;

        /* Start of bullet navigation */
        fm_bullets.querySelectorAll('li').forEach((bullet, i) => {
            bullet.addEventListener('click', (e) => {

                e.preventDefault();
                if (sliding) { return; } // Do nothing if sliding

                const currentIndex = Array.from(fm_bullets.querySelectorAll('li')).findIndex(node => node.classList.contains('active'));
                let direction = i > currentIndex ? 'next' : 'prev';

                // Calculate the actual distance taking into account the circular nature of the carousel
                let forwardDistance = (i - currentIndex + fm_slides.length) % fm_slides.length;
                let backwardDistance = (currentIndex - i + fm_slides.length) % fm_slides.length;

                // Determine the actual distance and direction based on the forward and backward distances
                let actualDistance = forwardDistance < backwardDistance ? forwardDistance : backwardDistance;

                const distance = Math.abs(i - currentIndex);
                // If the distance is more than half of the total slides, move in the opposite direction
                if (distance > fm_slides.length / 2) {
                    direction = direction === 'next' ? 'prev' : 'next';
                }
                
                // Slide the carousel to the target slide
                sliding = true; // Set sliding flag to true

                // Slide the carousel to the target slide
                for (let i = 0; i < actualDistance; i++) {
                    setTimeout(() => {
                        fm_slide(direction);
                        if (i === actualDistance - 1) { sliding = false; } // Reset sliding flag after the slide animation completes
                    }, (parseFloat(slideSpeed) + 100) * i);
                }
            });
        });
        /* End of bullet navigation */



        // Mobile swipe
        const diff = (a, b) => Math.abs(a - b);
        const setTouchstart = (e) => touchstart = e.changedTouches[0][touchDirection];
        const setTouchend = (e) => {
            touchend = e.changedTouches[0][touchDirection];
            if (touchend < touchstart && diff(touchstart, touchend) > 100) fm_slide('next');  // if swipe left and swipe distance is greater than 100px
            if (touchend > touchstart && diff(touchstart, touchend) > 100) fm_slide('prev'); // if swipe right and swipe distance is greater than 100px
        };

        toggleEventListeners(true);
    });
});